/* ============================================================
   UX FIX 27.7 - MAR SPORTWEAR - runtime patches
   [1]-[4] תיקוני באגים שנמדדו ב-Clarity (מובייל, ישראל, 22-29.7.2026)
   [5]-[9] שיפורי חזות 29-30.7
   [5]+[6] תוקנו 31.7 — שורת דמי המשלוח לא הופיעה בהוספה הראשונה לסל.
   הקובץ נטען לפני global.js ולכן יכול לעטוף פונקציות לפני שהן נרשמות.
   להסרה מלאה: למחוק קובץ זה + את השורות שנוספו בסוף
   snippets/meta-tags.liquid + את assets/mar-ux-fix-27-7.css
   ============================================================ */
(function () {
  'use strict';

  /* [1] שגיאת JS: "null is not an object (evaluating 'elementToFocus.focus')" */
  function patchTrapFocus() {
    var orig = window.trapFocus;
    if (typeof orig !== 'function' || orig.__uxFixPatched) return;
    var patched = function (container, elementToFocus) {
      try {
        return orig(container, elementToFocus || container);
      } catch (err) {
        console.warn('[UX-FIX] trapFocus:', err);
      }
    };
    patched.__uxFixPatched = true;
    window.trapFocus = patched;
  }

  /* [2] שגיאת JS: "Cannot read properties of undefined (reading 'classList')" ב-onVariantChange */
  if (window.customElements && customElements.define) {
    var origDefine = customElements.define.bind(customElements);
    customElements.define = function (name, C, opts) {
      try {
        if ((name === 'variant-radios' || name === 'variant-selects') &&
            C && C.prototype && typeof C.prototype.onVariantChange === 'function') {
          var origHandler = C.prototype.onVariantChange;
          C.prototype.onVariantChange = function (e) {
            try {
              return origHandler.call(this, e);
            } catch (err) {
              console.warn('[UX-FIX] onVariantChange:', err);
            }
          };
        }
      } catch (err) { /* לא עוצרים רישום קומפוננטות בשום מקרה */ }
      return origDefine(name, C, opts);
    };
  }

  /* [3] לחיצה על עיגול צבע בכרטיס מוצר — מיירוט המסלול השבור בלבד.
     בנוסף (באג 30.7): שם הצבע שמתחת לשם המוצר מתעדכן לפי הצבע שנבחר.
     אם השורה לא קיימת — יוצרים אותה. הקוד של הת'ים מרנדר מחדש את אזור
     המחיר אחרי החלפת צבע ועלול למחוק את השורה — לכן כותבים מיד וגם
     שוב אחרי שהרינדור נגמר, ומאזינים גם ל-change. */
  function marSetCardColor(colorCard, value) {
    if (!colorCard || !value) return;
    var colorEl = colorCard.querySelector('.mar-card-color');
    if (!colorEl) {
      var priceEl = colorCard.querySelector('.price');
      if (!priceEl || !priceEl.parentNode) return;
      colorEl = document.createElement('p');
      colorEl.className = 'mar-card-color';
      priceEl.parentNode.insertBefore(colorEl, priceEl);
    }
    if (colorEl.textContent !== value) colorEl.textContent = value;
  }
  function marSyncCardColor(input) {
    var colorCard = input.closest('.product-card-wrapper') || input.closest('.card-wrapper');
    if (!colorCard || !input.value) return;
    var marVal = input.value;
    marSetCardColor(colorCard, marVal);
    setTimeout(function () { marSetCardColor(colorCard, marVal); }, 350);
    setTimeout(function () { marSetCardColor(colorCard, marVal); }, 900);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('custom_variation_button')) return;
    marSyncCardColor(t);
  }, true);
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('custom_variation_button')) return;
    var card = target.closest('.product-card-wrapper');
    marSyncCardColor(target);
    var inline = card && card.querySelector('.product-card_inline-variation');
    var listen = inline && inline.querySelector('.product-form__input.listen_color_change');
    var match = null;
    if (listen) {
      var inputs = listen.querySelectorAll('input');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === target.value) { match = inputs[i]; break; }
      }
    }
    if (card && listen && match) return;
    e.stopPropagation();
    var label = target.closest('label');
    var url = label && label.getAttribute('data-variant-url');
    if (url) window.location.href = url;
  }, true);

  /* [4] דרופדאון מותאם (custom-select): לחיצה על הטקסט הפנימי או החץ */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var sel = e.target.closest('.custom-selected');
    if (!sel || e.target === sel) return;
    var cs = sel.closest('.custom-select');
    var opts = cs && cs.querySelector('.custom-select-options');
    if (opts) opts.classList.toggle('active');
  });

  /* [5] שקיפות דמי משלוח בעגלה — רק מתחת לסף משלוח חינם.
     אם מחירי המשלוח משתנים — לעדכן את הטקסט כאן. */
  function marEnsureShippingNote() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var footer = drawer.querySelector('.cart-drawer__footer');
    var existing = drawer.querySelector('.mar-shipping-note');
    var existingSuffix = drawer.querySelector('.mar-shipping-suffix');
    var overThreshold = !!drawer.querySelector('.free-shipping-message');
    /* באג שתוקן 31.7: אסור להסתמך על class="is-empty" של <cart-drawer>.
       בהוספה הראשונה לסל הת'ים מחליף את תוכן העגלה (innerHTML) ורק אחר כך
       מסיר את ה-class, ב-finally של product-form.js. המשגיח רץ בין השניים,
       ראה "עגלה ריקה" ולא הזריק כלום — והסרת ה-class כבר לא הפעילה אותו.
       לכן בודקים ישירות אם קיימות שורות פריט בסל. */
    var isEmpty = !drawer.querySelector('.cart-item');
    var shouldShow = footer && !isEmpty && !overThreshold;
    if (shouldShow && !existing) {
      var note = document.createElement('p');
      note.className = 'mar-shipping-note';
      note.textContent = 'דמי משלוח: ₪15 לנקודת איסוף / ₪19 עד הבית · חינם מעל ₪249';
      var totals = footer.querySelector('.totals');
      if (totals && totals.parentNode) {
        totals.parentNode.insertBefore(note, totals.nextSibling);
      } else {
        footer.appendChild(note);
      }
    } else if (!shouldShow && existing) {
      existing.remove();
    }
    var totalsRow = footer && footer.querySelector('.totals');
    if (shouldShow && totalsRow && !existingSuffix) {
      var suffix = document.createElement('span');
      suffix.className = 'mar-shipping-suffix';
      suffix.textContent = '+ דמי משלוח';
      totalsRow.appendChild(suffix);
    } else if (!shouldShow && existingSuffix) {
      existingSuffix.remove();
    }
  }

  /* [6] לוגיקת החץ "עוד פריטים בסל" הועברה כולה ל-assets/cart.js (תיקון יסודי, 29.7).
     כאן נשאר רק המשגיח של שורת המשלוח.
     31.7: נוסף דיבאונס, האזנה גם לשינוי class, ורשת ביטחון על אירוע cartUpdate,
     כדי שהשורה תיווצר בכל מסלול הוספה ולא רק בשינוי כמות. */
  function marWatchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__marShippingNoteWatched) return;
    drawer.__marShippingNoteWatched = true;
    marEnsureShippingNote();

    var pendingNote;
    function scheduleNote() {
      clearTimeout(pendingNote);
      pendingNote = setTimeout(marEnsureShippingNote, 60);
    }

    try {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var t = mutations[i].target;
          var el = t && (t.nodeType === 1 ? t : t.parentElement);
          /* שינויים שהשורה עצמה יוצרת מסוננים כדי שלא תיווצר לולאה */
          if (el && el.closest && el.closest('.mar-shipping-note, .mar-shipping-suffix')) continue;
          scheduleNote();
          break;
        }
      }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (err) { /* בלי Observer השורה לא תתעדכן ברענון, לא נשבר כלום */ }
  }

  /* [7] אריחי GIFT CARD + בלוג בתחתית תפריט הצד.
     מוזרק ב-JS כדי לא לגעת ב-header-drawer-matat.liquid הגדול. */
  function marAddMenuTiles() {
    var nav = document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (!nav || nav.querySelector('.mar-menu-tiles')) return;
    var list = nav.querySelector('.menu-drawer__menu.has-submenu') || nav.querySelector('.menu-drawer__menu');
    var wrap = document.createElement('div');
    wrap.className = 'mar-menu-tiles';
    wrap.innerHTML =
      '<a class="mar-menu-tile mar-menu-tile--gift" href="/products/gift-card">' +
        '<span class="mar-menu-tile__t">GIFT CARD</span>' +
        '<span class="mar-menu-tile__s">כרטיס מתנה</span>' +
      '</a>' +
      '<a class="mar-menu-tile mar-menu-tile--blog" href="/blogs/blog">' +
        '<span class="mar-menu-tile__t">BLOG</span>' +
        '<span class="mar-menu-tile__s">הבלוג שלנו</span>' +
      '</a>';
    if (list && list.parentNode) {
      list.parentNode.insertBefore(wrap, list.nextSibling);
    } else {
      nav.appendChild(wrap);
    }
  }

  /* [8] אריח קמפיין בתוך גריד המוצרים (בהשראת סטרונגפול).
     לשינוי הטקסט/הקישור/המיקום — לערוך את MAR_PROMO בלבד.
     לגרסת תמונה עם קרייטיב — להשתמש בבלוק Gallery Banner המובנה של הסקשן,
     ואז לבטל את האריח הזה (MAR_PROMO.enabled = false) כדי שלא יוצגו שניים. */
  var MAR_PROMO = {
    enabled: true,
    after: 4,
    minItems: 7,
    url: '/collections/sale',
    title: 'SALE',
    sub: 'לכל הפריטים במבצע',
    fine: 'משלוח חינם מעל ₪249'
  };
  function marIsCollectionPage() {
    return (document.body.className || '').indexOf('cstm-collection') !== -1;
  }
  function marAddGridPromo() {
    if (!MAR_PROMO.enabled || !marIsCollectionPage()) return;
    var grid = document.getElementById('product-grid') || document.querySelector('ul.product-grid');
    if (!grid || grid.querySelector('.mar-grid-promo')) return;
    /* אם הוגדר באנר מובנה לקולקציה הזו — לא מוסיפים שני */
    if (grid.querySelector('[class*="grid-banner-"]')) return;
    var items = grid.querySelectorAll('li.product-grid-item');
    if (items.length < MAR_PROMO.minItems) return;
    var anchor = items[Math.min(MAR_PROMO.after, items.length) - 1];
    if (!anchor || !anchor.parentNode) return;
    var li = document.createElement('li');
    li.className = anchor.className + ' mar-grid-promo';
    li.innerHTML =
      '<a class="mar-grid-promo__link" href="' + MAR_PROMO.url + '">' +
        '<span class="mar-grid-promo__t">' + MAR_PROMO.title + '</span>' +
        '<span class="mar-grid-promo__s">' + MAR_PROMO.sub + '</span>' +
        '<span class="mar-grid-promo__f">' + MAR_PROMO.fine + '</span>' +
      '</a>';
    anchor.parentNode.insertBefore(li, anchor.nextSibling);
  }

  /* [9] תיאור קטגוריה עם "קראי עוד" — רק אם הטקסט באמת נחתך. */
  function marCollectionReadMore() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc || desc.__marReadMore) return;
    if ((desc.textContent || '').trim().length === 0) return;
    desc.__marReadMore = true;
    desc.classList.add('mar-clamp');
    if (desc.scrollHeight - desc.clientHeight < 8) {
      desc.classList.remove('mar-clamp');
      return;
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mar-readmore';
    btn.textContent = 'קראי עוד';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('mar-clamp') === false;
      btn.textContent = open ? 'קראי פחות' : 'קראי עוד';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    desc.parentNode.insertBefore(btn, desc.nextSibling);
  }

  /* תוקן 31.7: [1] ורשת הביטחון של cartUpdate הוצאו מ-marInit.
     marInit רץ על DOMContentLoaded, וזה מוקדם מדי: הגלובלים של הת'ים
     (window.trapFocus, subscribe, PUB_SUB_EVENTS) מוגדרים ב-global.js
     שנטען עם defer ולכן עדיין לא קיימים באותו רגע. התוצאה הייתה ששני
     הפאצ'ים האלה יצאו מיד ב-return ולא הותקנו בכלל (קוד מת).
     אירוע load תמיד נורה אחרי כל סקריפטי ה-defer — שם הגלובלים כבר קיימים. */
  var marCartSubDone = false;
  function marSubscribeCartUpdate() {
    if (marCartSubDone) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          setTimeout(marEnsureShippingNote, 80);
          setTimeout(marEnsureShippingNote, 450);
        });
        marCartSubDone = true;
      } catch (err) { /* אין pubsub — נשארים עם המשגיח */ }
    }
  }

  function marLatePatches() {
    patchTrapFocus();
    marSubscribeCartUpdate();
  }

  function marInit() {
    marWatchCartDrawer();
    marAddMenuTiles();
    marAddGridPromo();
    marCollectionReadMore();
    setTimeout(function () {
      marAddMenuTiles();
      marAddGridPromo();
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', marInit);
  } else {
    marInit();
  }

  if (document.readyState === 'complete') {
    marLatePatches();
  } else {
    window.addEventListener('load', marLatePatches);
  }
})();